import axios from "axios";
import { SignInData } from "../../api-types/sign-in";
import { SIGN_IN_URL } from "../utils";

export const signIn = async (signInData: SignInData) => {
  return await axios.post(SIGN_IN_URL, signInData);
};
